import Cookies from "js-cookie";

export const setCookie = (key, value, expiresDays = 1) => {
  if (typeof value === "string") {
    Cookies.set(key, value, {expires: expiresDays, secure: true, sameSite: "strict"});
  }
  Cookies.set(key, JSON.stringify(value), {expires: expiresDays, secure: true, sameSite: "strict"});
};

export const getCookie = key => {
  const value = Cookies.get(key);
  if (!value) {
    return null;
  }
  return JSON.parse(value);
};

export const removeCookie = key => {
  Cookies.remove(key);
};
